import { render, staticRenderFns } from "./SlideMenuCollapse.vue?vue&type=template&id=90e3b5b2&scoped=true&"
import script from "./SlideMenuCollapse.vue?vue&type=script&lang=js&"
export * from "./SlideMenuCollapse.vue?vue&type=script&lang=js&"
import style0 from "./SlideMenuCollapse.vue?vue&type=style&index=0&id=90e3b5b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e3b5b2",
  null
  
)

export default component.exports